import { passiveSupported } from './Helpers';

//create sticky-nav
const titles = document.querySelectorAll('h2');

for (let i = 0; i < titles.length; i++) {
    titles[i].id = 'title' + i.toString();
}

const menu = document.querySelector<HTMLElement>('#my-sticky-nav');

if (menu) {
    menu.innerHTML = Array.from(titles)
        .map(
            (title: HTMLElement) => `
        <li data-scrollspy="${title.id}">
          <div class="scroll-indicator__nav">
            <div class="scroll-indicator__progress"></div>
          </div>
          <a href="#${title.id}">${title.textContent ?? ''}</a>
        </li>`
        )
        .join('');

    if (titles.length === 0) {
        const menuTitle = document.querySelector<HTMLElement>('.sticky-nav');
        menuTitle?.classList.add('hidden');
    }
}

if (menu != null && titles.length > 0) {
    //scrollspy nav
    const scrollSpy = () => {
        const objs = document.querySelectorAll('h2');
        objs.forEach((title: HTMLElement) => {
            const el = document.querySelector(
                'li[data-scrollspy="' + title.id + '"]'
            );

            const isLast =
                window.innerHeight + window.scrollY >=
                document.documentElement.scrollHeight - 20;

            if (title.getBoundingClientRect().top < 40 || isLast) {
                if (el && !el.classList.contains('active')) {
                    el.classList.add('active');
                }
                return;
            } else {
                if (el && el.classList.contains('active')) {
                    el.classList.remove('active');
                }
                return;
            }
        });
    };

    const stickyNav = document.querySelector<HTMLElement>('.sticky-nav');

    const scrollSpyLine = () => {
        const items =
            document.querySelectorAll<HTMLLIElement>('#my-sticky-nav li');

        items.forEach((li) => {
            const targetId = li.dataset.scrollspy;
            if (!targetId) return;

            const currentTitle = document.getElementById(targetId);
            if (!currentTitle) return;

            const nextLi = li.nextElementSibling as HTMLLIElement | null;

            const progressBar = li.querySelector<HTMLElement>(
                '.scroll-indicator__progress'
            );
            if (!progressBar) return;

            if (nextLi) {
                const nextTargetId = nextLi.dataset.scrollspy;
                if (!nextTargetId) return;

                const nextTitle = document.getElementById(nextTargetId);
                if (!nextTitle) return;

                const posCurrentTitle =
                    currentTitle.getBoundingClientRect().top;
                const posNextTitle = nextTitle.getBoundingClientRect().top;
                const dist = posNextTitle - posCurrentTitle;

                if (dist <= 0) return;

                const percent = (posCurrentTitle / dist) * -100;

                if (percent <= 0) {
                    progressBar.style.height = '0%';
                } else if (percent <= 100) {
                    progressBar.style.height = `${percent}%`;
                } else {
                    progressBar.style.height = '100%';
                }
            }

            if (
                document.documentElement.scrollHeight -
                    (window.scrollY + window.innerHeight) <=
                20
            ) {
                progressBar.style.height = '100%';
            }
        });
    };

    window.addEventListener(
        'scroll',
        () => {
            if (stickyNav) {
                scrollSpy();
                scrollSpyLine();
            }
        },
        passiveSupported ? { passive: true } : false
    );

    window.addEventListener('DOMContentLoad', () => {
        if (stickyNav) {
            scrollSpy();
            scrollSpyLine();
        }
    });
}
